<template>
  <b-modal
    :id="id"
    scrollable
    size="md"
    ok-only
    ok-title="Chiudi"
    ok-variant="lisaweb"
    header-bg-variant="lisaweb"
    no-close-on-esc
    no-close-on-backdrop
  >
    <template #modal-header="{ cancel }">
      <div slot="modal-title" class="modal-title">
        <b-icon icon="file-earmark"></b-icon>
        <span>Documenti</span>
      </div>
      <button
        type="button"
        class="close"
        title="Chiudi"
        data-dismiss="modal"
        @click="cancel()"
      >
        &times;
      </button>
    </template>
    <div class="tableFixHead">
      <table>
        <thead>
          <tr>
            <th>Descrizione</th>
            <th>Nota</th>
            <th>Estensione</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(document, index) in items" v-bind:key="index">
            <td>{{ document.title }}</td>
            <td>{{ document.note }}</td>
            <td>{{ document.extension }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "documentDetail",
  data() {
    return {};
  },
  props: {
    items: Array,
    id: {
      type: String,
      default: "documentDetailModal",
    },
  },
};
</script>
<style scoped>
/* Just common table stuff. Really. */
table {
  border-collapse: collapse;
  width: 100%;
}
</style>
